import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { NotesProvider } from '@models/notes-provider.interface';
import { NoteDto } from '@models/note-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class DesignNotesProvider implements NotesProvider {
  private readonly apiService = inject(ApiService);

  getNotes(designId: number): Observable<NoteDto[]> {
    return this.apiService.get(`designs/${designId}/notes`);
  }

  addNote(designId: number, text: string): Observable<unknown> {
    return this.apiService.post(`designs/${designId}/notes`, { text });
  }

  updateNote(designId: number, noteId: number, text: string): Observable<unknown> {
    return this.apiService.put(`designs/${designId}/notes/${noteId}`, { text });
  }

  deleteNote(designId: number, noteId: number): Observable<unknown> {
    return this.apiService.delete(`designs/${designId}/notes/${noteId}`);
  }
}
